import {
  type ToolRegistryItem,
  createInstructionManifest,
  deleteInstructionManifest,
  moveInstructionManifest,
  readInstructionManifest,
  searchInstructionsManifest,
  updateInstructionManifest,
} from '@packages/systems/ai/tool-registry/shared';

/**
 * These are server-side MCP tools that do not have a corresponding server tool.
 */
export const mcpToolsMap: Partial<
  Record<ToolRegistryItem['id'], ToolRegistryItem>
> = {
  [createInstructionManifest.id]: createInstructionManifest,
  [deleteInstructionManifest.id]: deleteInstructionManifest,
  [moveInstructionManifest.id]: moveInstructionManifest,
  [readInstructionManifest.id]: readInstructionManifest,
  [searchInstructionsManifest.id]: searchInstructionsManifest,
  [updateInstructionManifest.id]: updateInstructionManifest,
};
